import { render, staticRenderFns } from "./CreateSanctionDialog.vue?vue&type=template&id=23b53e72"
import script from "./CreateSanctionDialog.vue?vue&type=script&lang=js"
export * from "./CreateSanctionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports